module.exports = __webpack_public_path__ + "img/noPK.95010e38.png";